import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
      <div className="bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-background-200/70">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-foreground-900">漫画分类</h3>
          <Link to="/category/all" className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer">
            查看全部 <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-10 gap-2">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-3 rounded-xl hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-500 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-xs text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}